import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchUsers'
})
export class SearchUsersPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!args) {
      return value;
    }
    return value.filter((val: any) => {
      let rVal = (val.userName.toLocaleLowerCase().includes(args));
      return rVal;
    })
  }

}
